import { QueryParametersState } from "@idw-types/state";
import fetch from "cross-fetch";

export const getVerificationConfiguration = async (queryParameters: QueryParametersState): Promise<Response> => {   
    let route = queryParameters.configUrl;
    if (route.includes("?")) {
        route += `&newResponse=t&cb=${new Date().getTime()}`;
    } else {
        route += `?newResponse=t&cb=${new Date().getTime()}`;
    }
    const request = {
        headers: {
            "Content-Type": "application/json"
        },
        method: "GET"
    };
    return fetch(route, request);
};